exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-50d081b0]{color:#fff;background-color:green;text-align:center;padding:15px;width:auto;margin-left:1%;float:left;margin-right:2%}@media(min-width:768px){h3[data-v-50d081b0]{margin-left:4%;margin-right:0}}.timeout[data-v-50d081b0]{background-color:#ff0037}", ""]);

// exports
